module.exports = __webpack_public_path__ + "img/spinner.0afa65a9.gif";